(function ($) {
  domReady = function () {
    //console.log('Mobile:'+$.script.ua().Mobile);
    //console.log('Tablet:'+$.script.ua().Tablet);

    //　画面サイズごとの画像切替
    $.script.responsiveImage();

    // [PCのみ]グローバルナビゲーション背景処理
    $.script.setGnavBg();

    //　グローバルナビゲーション
    $.script.setUpMenu();

    //　ページ内スクロール
    $.script.pageScroll();

    //　電話リンク
    $.script.phoneLink();

    //　fixedレイアウトの横スクロール処理
    $.script.fixedLayout();

    //　google検索窓移動
    $.script.searchMove();

    //　ページトップへスクロール
    $.script.scrollPageTop();

    //　カートへスクロール
    $.script.scrollGotoCart();

    //　アコーディオンナビゲーション
    $.script.toggleNavigation();

    // アイテム　高さぞろえ
    $.script.voiceHeight();

    // お客様の声　スライダー
    $.script.voiceSlider();

    //バナーのスライダー
    $.script.bannerSlider();

    // トップページのスライダー
    if ($(".cat-top").length > 0) {
      $.script.topSlider();
      $.script.topHeight();
    }

    //[iOS対策] readonlyのフォーカスを外す
    $.script.formFocus();

    if (platform.name == "Safari") {
      $("html").addClass("is-safari");
    }
    if (platform.name == "IE") {
      $("html").addClass("is-ie");
      if (platform.version == "11.0") {
        $("html").addClass("is-ie11");
      }
    }
    if (platform.name == "Microsoft Edge") {
      $("html").addClass("is-edge");
    }

    //SP用テーブルレイアウト
    if ($(".js-table-wrap table").length > 0) {
      $.script.scrollTable();
    }
  };

  $.script = {
    ua: function () {
      var u = window.navigator.userAgent.toLowerCase();
      return {
        Tablet:
          (u.indexOf("windows") != -1 &&
            u.indexOf("touch") != -1 &&
            u.indexOf("tablet pc") == -1) ||
          u.indexOf("ipad") != -1 ||
          (u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
          (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
          u.indexOf("kindle") != -1 ||
          u.indexOf("silk") != -1 ||
          u.indexOf("playbook") != -1,
        Mobile:
          (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
          u.indexOf("iphone") != -1 ||
          u.indexOf("ipod") != -1 ||
          (u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
          (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) ||
          u.indexOf("blackberry") != -1,
      };
    },
    isMobile: function () {
      var result = false;
      if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
        $("html").addClass("is-mobile");
        result = true;
      }
      return result;
    },
    isPCView: function () {
      var w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      return 767 < w ? true : false;
    },
    /**============================================================
    *   [responsiveImage]
    *   description : スマホ用・デスクトップ用の画像を切り替える処理を記述
    *               : 適用するimg要素に「js-image」クラスを付与
    ============================================================*/
    responsiveImage: function () {
      var self = this;
      var $setElem = $(".js-image");

      var getWidth = function (target, reg) {
        var pattern = new RegExp("^" + reg);
        for (var i = 0, len = target.length; i < len; i++) {
          if (target[i].match(pattern)) {
            return target[i].replace(reg, "");
          }
        }
      };

      $setElem.each(function () {
        var $this = $(this);
        var imageW = getWidth($(this).attr("class").split(" "), "sp-w-");

        function replaceImage() {
          if (self.isPCView()) {
            $this
              .attr(
                "src",
                $this.attr("src").replace(/^(.+)_sp(\.[a-z]+)$/, "$1$2")
              )
              .css({ visibility: "visible" });
            $this.attr("style", "");
          } else {
            if ($this.attr("src").indexOf("_sp") == -1) {
              $this
                .attr(
                  "src",
                  $this.attr("src").replace(/^(.+)(\.[a-z]+)$/, "$1_sp$2")
                )
                .css({ visibility: "visible" });
            }

            //スマホ時の幅
            if (imageW != "") {
              $this.css("width", imageW);
            }
          }
        }

        //[OrientationChange] ブレイク処理
        var mql = window.matchMedia("(min-width: 767px)");
        mql.addListener(handleOrientationChange);
        handleOrientationChange(mql);
        function handleOrientationChange(mql) {
          replaceImage();
        }
        replaceImage();
      });
    },
    /**============================================================
    *   [setGnavBg]
    *   description : 【PC】グローバルナビゲーション背景の表示に適用する処理を記述
    ============================================================*/
    setGnavBg: function () {
      var $gnavBg = $(".js-gnav-bg"),
        $gnavParentBtn = $(".gnav-parent-lv1 > .gnav-link-lv1"),
        _gnavH = 0;

      function setAction() {
        $gnavParentBtn.on("click", function () {
          //自身がactiveの場合閉じる
          if ($(this).hasClass("is-toggle-button-active")) {
            $gnavBg.removeClass("is-show");
            $gnavBg.css("height", 0);
          } else {
            $gnavBg.addClass("is-show");
            var target = $(this).attr("data-target");
            _gnavH = $(target).height();
            $gnavBg.css("height", _gnavH);
          }
        });

        $(".l-content-wrap").on("click", function (e) {
          if ($gnavBg.hasClass("is-show")) {
            $gnavBg.removeClass("is-show");
            $gnavBg.css("height", 0);

            $gnavParentBtn.each(function () {
              var navTarget = $(this).attr("data-target");

              $(navTarget).hide();
              $(navTarget).addClass("is-toggle-hidden");
              $(navTarget).removeClass("is-toggle-active");

              $(this).removeClass("is-toggle-button-active");
              $(this).addClass("is-toggle-button-hidden");
            });
          }
        });
      }
      if ($.script.isPCView() === true) {
        setAction();
      }
    },
    /**============================================================
    *   [globalNavigation]
    *   description : グローバルナビゲーションに適用する処理を記述
    ============================================================*/
    setUpMenu: function () {
      var $trigger = $("#js-gnav-trigger"),
        $menu = $("#js-gnav"),
        $menuLink = $menu.find("a"), //ページ内リンク判定用
        $contentWrap = $("#js-content-wrap"),
        $menuCover = $("#js-gnav-cover"),
        $grade = $("#js-header-grad"),
        $burgerText = $("#js-burger-text"),
        $tell = $("#js-tel"),
        mouseStart = "ontouchstart" in window ? "touchstart" : "click",
        mouseEnd = "ontouchstart" in window ? "touchend" : "click",
        transitionEnd =
          "oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend",
        isShow,
        self = this,
        $header = $(".l-header"),
        $headerButtons = $(".header-button-container"), //開閉時に移動（css）
        $gnavWrapper = $(".gnav-scroll-wrapper"), //グロナビスクロール範囲（jsでheightつける）
        $html = $("html"), //グロナビ開いた際に隠す（css）
        $pagetop = $("#js-page-top"),
        $gotocart = $("#js-goto-cart"),
        $gnavAnimCnt = $("#js-gnav .gnav"),
        $menuClose = $("#js-gnav-close");

      var menuShow = function () {
        $trigger.addClass("is-show");
        $menu.addClass("is-show");
        $contentWrap.addClass("is-show");
        $menuCover.addClass("is-show");
        $grade.addClass("is-show");
        $burgerText.text("CLOSE");

        $header.addClass("is-gnav-show");
        $headerButtons.addClass("is-gnav-show");
        $pagetop.addClass("is-gnav-show");
        $gotocart.addClass("is-gnav-show");
        
        $html.addClass("is-gnav-show");

        $gnavAnimCnt.addClass("is-gnav-show");
      };

      var menuHide = function () {
        $trigger.removeClass("is-show");
        $menu.removeClass("is-show").removeClass("is-fixed");
        $contentWrap.removeClass("is-show");
        $menuCover.removeClass("is-show");
        $grade.removeClass("is-show");
        $burgerText.text("MENU");

        $header.removeClass("is-gnav-show");
        $headerButtons.removeClass("is-gnav-show");
        $pagetop.removeClass("is-gnav-show");
        $gotocart.removeClass("is-gnav-show");

        $html.removeClass("is-gnav-show");

        $gnavAnimCnt.addClass("is-gnav-closing");

        //閉じてから
        var timeGnavAnim = false;
        if (timeGnavAnim !== false) {
          clearTimeout(timeGnavAnim);
        }
        timeGnavAnim = setTimeout(function () {
          $gnavAnimCnt.removeClass("is-gnav-closing");
          $gnavAnimCnt.removeClass("is-gnav-show");
        }, 500);
      };

      var setEvent = function () {
        var busy = 0;

        $menuClose.on("click", function (event) {
          event.preventDefault();
          isShow = false;
          menuHide();
        });
        $trigger.on("click", function (event) {
          if (busy == 1) return false;
          if (isShow) {
            isShow = false;
            menuHide();
          } else {
            isShow = true;
            $menu.addClass("is-visible");
            menuShow();
          }
          busy = 1;
          setTimeout(function () {
            busy = 0;
          }, 500);
        });
        $contentWrap.on(transitionEnd, function () {
          if (!isShow) {
            $menu.removeClass("is-visible");
          }
        });
        $menuCover.on("click", function () {
          if (isShow) {
            isShow = false;
            menuHide();
          }
        });
        $menuLink.on(mouseStart, function () {
          var hash = $(this.hash);
          var loc = location.href;

          if ($(hash).selector != "") {
            $("html, body")
              .stop()
              .animate({ scrollTop: $(hash).offset().top }, 600, "swing");
            if (isShow) {
              isShow = false;
              setTimeout(menuHide, 500);
            }
          }
        });
      };
      setEvent();
    },
    /**============================================================
    *  [searchMove]
    *  description : google検索窓のDOMを移動させるスクリプト（PC・SPで配置が違うため）
    ============================================================*/
    searchMove: function () {
      //HTMLでid=to_topに指定したボタンを使用
      var $gnavSearch = $(".js-gnav-search-sp");

      // リサイズ時の処理
      var resizeCallback = function (event) {
        if (
          $.script.isPCView() === true &&
          $(".js-gnav-search-sp").length > 0
        ) {
          $(".js-gnav-search-sp").replaceWith(function () {
            $(this).appendTo(".l-header-inner");
            $(this).replaceWith(
              $('<div class="js-gnav-search-pc gnav-list"/>').html(
                $(this).html()
              )
            );
          });
        } else if (
          $.script.isPCView() != true &&
          $(".js-gnav-search-pc").length > 0
        ) {
          $(".js-gnav-search-pc").replaceWith(function () {
            $(this).insertBefore(".js-gnav-contact");
            $(this).replaceWith(
              $('<li class="js-gnav-search-sp gnav-list"/>').html(
                $(this).html()
              )
            );
          });
        }
      };
      $(window).on("resize orientationchange", resizeCallback);

      //init
      if ($.script.isPCView() === true) {
        $gnavSearch.replaceWith(function () {
          $(this).appendTo(".l-header-inner");
          $(this).replaceWith(
            $('<div class="js-gnav-search-pc gnav-list"/>').html($(this).html())
          );
        });
      }
    },
    /**============================================================
    *  [scrollPageTop]
    *  description :
    ============================================================*/
    scrollPageTop: function () {
      //HTMLでid=to_topに指定したボタンを使用
      var $toTopBtn = $("#js-page-top");
      var showFlag = false;
      var positionCurrent = 0;

      $(window).scroll(function () {
        //positionDiffは、0より小さい時は下スクロール、0より大きい時は上スクロールしたことになる。
        positionDiff = positionCurrent - $(window).scrollTop();
        positionCurrent = $(window).scrollTop();

        if ($.script.isPCView() === true) {
          //PC
          if ($(this).scrollTop() > 100) {
            $toTopBtn.addClass("is-visible");
          } else {
            $toTopBtn.removeClass("is-visible");
          }
        } else {
          //上スクロールかつウィンドウの一番上にいない、またはウィンドウの一番下である時、fadeIn表示。
          if (
            (positionDiff > 0 && positionCurrent > 0) ||
            positionCurrent + $(window).height() >= $(document).height()
          ) {
            if (!showFlag) {
              $toTopBtn.addClass("is-visible");
              showFlag = true;
            }
          } else {
            $toTopBtn.removeClass("is-visible");
            showFlag = false;
          }
        }
      });

      $("#js-page-top").on("click", function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 500);
      });
    },
    
   /**============================================================
    *  [scrollGotoCart]
    *  description :
    ============================================================*/
    scrollGotoCart: function () {
      var $toCartBtn = $("#js-goto-cart");
      var ajustValue = 100;
      if ($.script.isPCView() === true) {
        ajustValue = 140;
      }
      if ($("#js-form-cart").length > 0) {
        $toCartBtn.addClass("is-visible");
        $toCartBtn.addClass("is-visible");
          $("#js-goto-cart").on("click", function(e) {
              e.preventDefault();
              $("html, body").animate({ scrollTop: $("#js-form-cart").offset().top - ajustValue }, 500);
              $toCartBtn.removeClass("is-visible");
          });
      } else{
        $toCartBtn.removeClass("is-visible");
      }
    },
    /**============================================================
    *  [phoneLink]
    *  description : PCの際に電話のリンクを削除する処理を記述
    ============================================================*/
    phoneLink: function () {
      var $phoneLink;

      if (!$.script.isMobile() && $(".js-phone-link").length > 0) {
        $(".js-phone-link").each(function () {
          $phoneLink = $(this).html();
          $(this).replaceWith(
            '<span class="js-phone-link">' + $phoneLink + "</span>"
          );
        });
      }
    },
    /**============================================================
    *   [fixedLayout]
    *   description : fixed要素の横スクロールに適用するjs
    ============================================================*/
    fixedLayout: function () {
      var fixedFlg = false;

      if ($(".js-fixed").length > 0) {
        fixedFlg = $(".js-fixed").css("position") === "fixed" ? true : false;
      }
      //fixedの要素の横スクロール（横スクロールできない問題を回避）
      function fixedScrollBar() {
        $(window).on("load scroll resize", function () {
          if (fixedFlg === true) {
            if (window.matchMedia("(min-width:738px)").matches) {
              $(".js-fixed").css("left", -$(window).scrollLeft());
            } else {
              //mobile
              $(".js-fixed").css("left", "inherit");
            }
          }
        });
      }
      //init
      if ($.script.isPCView() === true) {
        fixedScrollBar();
      }
    },
    /**============================================================
    *  [pageScroll]
    *  description : アンカーのページスクロールの処理を記述
    ============================================================*/
    pageScroll: function () {
      var self = this,
        speed = 300,
        fixedH = 0,
        topPos;

      if ($(".header-container").length > 0) {
        fixedH =
          $(".header-container").css("position") === "fixed"
            ? $(".header-container").height()
            : 0;
      }

      $("a[href^='#']:not(.pagetop-link,.js-toggle)").on("click", function () {
        if ($(this.hash).length > 0) {
          topPos = $(this.hash).offset().top;
          $("html, body").stop().animate({ scrollTop: topPos }, 250, "swing");
          return false;
        }
      });
      $(".pagetop-link").on("click", function () {
        $("html, body").stop().animate({ scrollTop: 0 }, 250, "swing");
        return false;
      });
    },
    /**============================================================
    *  [toggleNavigation]
    *  description : アコーディオン処理に適用する処理を記述
    *               : アコーディオンのボタン設定（※は必須）
    *                 1. クラス名※             .js-toggle
    *                 2. ターゲット※            data-target="#xxxxx"
    *                 3. 開いた状態              .is-toggle-button-active（デフォルトで開く場合は、クラスを追加）
    *                 4. 動作の種類              data-action="open | close | both (default)"
    *                 5. 開閉時のスクロール位置    data-top="#xxxxx"
    *                 6. スマホかPCか両方か       data-state="desktop | mobile | both (default)"
    *                 7. 他を閉じるか            data-group="任意のグループ名 | false (default)"
    *               : アコーディオンのターゲット設定（任意）
    *                 URLでハッシュを使用する場合、URLとターゲットのIDを以下のように設定すること。
    *                 8. URL・・・・・・・#aaa
    *                 9. ターゲットID・・#aaa-toggle
    ============================================================*/
    toggleNavigation: function () {
      var hash = window.location.hash + "-toggle",
        speed = 200,
        position,
        stateFlg,
        fixedH =
          $(".header-container").css("position") === "fixed"
            ? $(".header-container").height()
            : 0,
        _isGroup = false;

      function navTargetTop(t) {
        position = $(t).offset().top - fixedH;
        return position;
      }

      function setToggleNav(button) {
        //1. 各ボタン設定
        button.each(function () {
          //2. ターゲット
          var navTarget = $(this).attr("data-target");
          //6.
          var navState = $(this).attr("data-state");

          if (stateFlg === navState || !navState || navState === "default") {
            //3. ボタンがactiveであればターゲットを開く。無ければhiddenクラスを追加
            if ($(this).hasClass("is-toggle-button-active")) {
              $(navTarget).addClass("is-toggle-active");
            } else {
              $(navTarget).hide().addClass("is-toggle-hidden");
              $(this).addClass("is-toggle-button-hidden");
            }

            $(this).on("click", function (e) {
              e.preventDefault();
              e.stopPropagation();

              var action = $(this).attr("data-action");
              var group = $(this).attr("data-group");
              var $groupElem = $('[data-group="' + group + '"]');
              var groupElemTarget = $groupElem.attr("data-target");
              var $topElem = $(this).attr("data-top");
              var $Elem = $(this);
              var _scrollFlg = true;

              group = group != "" ? group : false;
              $topElem = $topElem != "no" ? $topElem : false;

              if (
                $(navTarget).hasClass("is-toggle-active") &&
                action != "open"
              ) {
                // 開いていたら閉じる
                $(navTarget).stop().slideUp(speed);
                $(navTarget).removeClass("is-toggle-active");
                $(navTarget).addClass("is-toggle-hidden");
                $(this).removeClass("is-toggle-button-active");
                $(this).addClass("is-toggle-button-hidden");
                $('[data-target="' + navTarget + '"]').removeClass(
                  "is-toggle-button-active"
                );
                $('[data-target="' + navTarget + '"]').addClass(
                  "is-toggle-button-hidden"
                );
              } else if (action != "close") {
                var _isOpen = false;

                //7. 他を閉じるか
                if (group != false) {
                  //グループあり

                  $($groupElem).each(function () {
                    var groupT = $(this).attr("data-target");
                    if ($(groupT).hasClass("is-toggle-active")) {
                      _isOpen = true;
                    }

                    $(groupT).each(function () {
                      if ($(this).hasClass("is-toggle-active")) {
                        $(this).stop().slideUp(speed);
                        $(this).removeClass("is-toggle-active");
                        $(this).addClass("is-toggle-hidden");
                      }
                    });
                    $('[data-group="' + group + '"]').removeClass(
                      "is-toggle-button-active"
                    );
                    $('[data-group="' + group + '"]').addClass(
                      "is-toggle-button-hidden"
                    );
                  });

                  var timerToggleGroup = false;

                  if ($topElem != false) {
                    //スクロールするモード

                    var delay = $topElem == false ? 0 : _isOpen ? 200 : 0; //他が開いてなかったらdelayなし

                    if (timerToggleGroup !== false) {
                      clearTimeout(timerToggleGroup);
                    }
                    timerToggleGroup = setTimeout(function () {
                      //閉じていたら開く
                      $(navTarget).stop().slideDown(speed);
                      $Elem.removeClass("is-toggle-button-hidden");
                      $Elem.addClass("is-toggle-button-active");
                      $(navTarget).removeClass("is-toggle-hidden");
                      $(navTarget).addClass("is-toggle-active");

                      //5. スクロール位置の指定があれば、そのtopへ移動。無ければターゲットのtopに移動
                      if ($topElem != false) {
                        position = navTargetTop($topElem);
                        // if($.script.isPCView() === true){
                        //   position = position + 110;
                        // }else{
                        //   position = position + 54;
                        // }
                        $("html, body")
                          .stop()
                          .animate({ scrollTop: position }, speed, "swing");
                        _scrollFlg = false;
                      }
                    }, delay);
                  } else {
                    //スクロールしないモード（開くだけ）

                    //閉じていたら開く
                    $(navTarget).stop().slideDown(speed);
                    $Elem.removeClass("is-toggle-button-hidden");
                    $Elem.addClass("is-toggle-button-active");
                    $(navTarget).removeClass("is-toggle-hidden");
                    $(navTarget).addClass("is-toggle-active");
                  }
                } else {
                  //グループなし
                  $(navTarget).stop().slideDown(speed);
                  $(this).removeClass("is-toggle-button-hidden");
                  $(this).addClass("is-toggle-button-active");
                  $(navTarget).removeClass("is-toggle-hidden");
                  $(navTarget).addClass("is-toggle-active");
                }
              }
              //5. スクロール位置の指定があれば、そのtopへ移動。無ければターゲットのtopに移動
              if ($topElem && _scrollFlg == true) {
                position = navTargetTop($topElem);
                $("html, body")
                  .stop()
                  .animate({ scrollTop: position }, speed, "swing");
                _scrollFlg = false;
              }
            });
          }
        });

        //8. ハッシュのコンテンツがあれば表示
        if (hash && $(hash).length > 0) {
          $(hash).show();
          $('[data-target="' + hash + '"]').removeClass(
            "is-toggle-button-hidden"
          );
          $('[data-target="' + hash + '"]').addClass("is-toggle-button-active");

          $(hash).removeClass("is-toggle-hidden");
          $(hash).addClass("is-toggle-active");

          //5.
          if ($('[data-target="' + hash + '"]').attr("data-top")) {
            position = navTargetTop(
              $('[data-target="' + hash + '"]').attr("data-top")
            );
          } else {
            position = navTargetTop(hash);
          }

          $("html, body")
            .stop()
            .animate({ scrollTop: position }, speed, "swing");
        }
      }

      //トグル機能削除
      function resetToggleNav(button) {
        button.each(function () {
          var navTarget = $(this).attr("data-target");

          $(this)
            .off()
            .removeClass("is-toggle-button-active is-toggle-button-hidden")
            .attr("style", "");
          $(navTarget)
            .removeClass("is-toggle-active is-toggle-hidden")
            .attr("style", "");
        });
      }

      //resize
      var timerToggle = false;
      $(window).resize(function () {
        if (timerToggle !== false) {
          clearTimeout(timerToggle);
        }
        timerToggle = setTimeout(function () {
          //モバイルとデスクトップ表示の分岐
          if ($.script.isPCView() === true && stateFlg === "mobile") {
            stateFlg = "desktop";

            if ($('[data-state="mobile"]').length > 0) {
              resetToggleNav($('[data-state="mobile"]'));
            }
            if ($('[data-state="desktop"]').length > 0) {
              setToggleNav($('[data-state="desktop"]'));
            }
          } else if ($.script.isPCView() != true && stateFlg === "desktop") {
            stateFlg = "mobile";

            if ($('[data-state="desktop"]').length > 0) {
              resetToggleNav($('[data-state="desktop"]'));
            }
            if ($('[data-state="mobile"]').length > 0) {
              setToggleNav($('[data-state="mobile"]'));
            }
          }
        }, 100);
      });

      //init
      if ($.script.isPCView() === true) {
        stateFlg = "desktop";
      } else {
        stateFlg = "mobile";
      }

      setToggleNav($(".js-toggle"));
    },
    /**============================================================
    *  [voiceHeight]
    *  description : お客様の声　高さぞろえ
    ============================================================*/
    voiceHeight: function () {
      var $itemHeight = $(".js-item-height");
      var self = this;
      var stateFlg;

      //ロード時
      $(window).on("load", function () {
        //[voice]
        $(".m-voice-item .inner").each(function () {
          var h = $(this).height();

          //400より高かったら隠す
          if ($.script.isPCView() === true && h > 400) {
            $(this).closest(".m-voice-item").addClass("read-more"); //PC用
          }
          if ($.script.isPCView() === false && h > 400) {
            $(this).closest(".m-voice-item").addClass("read-more--sp"); //スマホ用
          }
          //数値計算終わったら高さ固定
          $(this).addClass("set-height");
        });
      });

      //リサイズ時
      $(window).on("resize", function () {
        //[トップ]
        if ($(".cat-top").length > 0) {
          //スマホ 高さリセット
          if ($.script.isPCView() === false) {
            $(".m-voice-item .inner").removeClass("set-height"); //高さクラス削除
            $(".m-voice-item .inner").each(function () {
              var h = $(this).height();

              //400より高かったら隠す
              if (h > 400) {
                $(this).closest(".m-voice-item").addClass("read-more--sp");
              }
              $(this).addClass("set-height");
            });
          }
        } else {
          //[下層]
          if ($.script.isPCView() === true) {
            //PC 高さぞろえ
            if (stateFlg == "mobile") {
              $(".m-voice-list").each(function () {
                $(".m-voice-item").find(".inner").tile();
              });
              stateFlg = "desktop";
            }
          } else {
            //スマホ 高さ成り行き
            $(".m-voice-list").each(function () {
              $(".m-voice-item").find(".inner").attr("style", "");
            });
            if (stateFlg == "desktop") {
              stateFlg = "mobile";
            }
          }
        }
      });

      if ($.script.isPCView() === true) {
        stateFlg = "desktop";
      } else {
        stateFlg = "mobile";
      }
    },
    /**============================================================
    *  [formFocus]
    *  description : iOS対策 readonlyのformのフォーカスを外す
    ============================================================*/
    formFocus: function () {
      $("input").each(function () {
        if ($(this).attr("readonly") == "readonly") {
          $(this).focus(function () {
            $(this).blur();
          });
        }
      });
    },
    /**============================================================
    *  [voiceSlider]
    *  description : 声一覧のスライドに適用する処理を記述
    ============================================================*/
    voiceSlider: function () {
      ($slider = $("#js-voice-slider")),
        (slideH = $("#js-voice-slider .m-voice-item").height()),
        (slideMode = "desktop"),
        (oldSlideMode = ""),
        (visibleMin = $.script.isPCView() === true ? 3 : 1);

      function setSlider() {
        $slider.carouFredSel({
          // swipe: {
          //   onTouch:true,
          //   onMouse:true
          // },
          //responsive: true, positionバグる
          height: "variable",
          items: {
            height: "variable",
            visible: {
              //"+2"
              min: visibleMin,
              //,max: 3
            },
          },
          padding: [0, 15],
          scroll: {
            items: 1,
          },
          auto: false,
          width: "100%",
          align: "center",
          prev: ".m-voice-slide-control.prev",
          next: ".m-voice-slide-control.next",
        });
      }
      //init
      if ($("#js-voice-slider").length > 0) {
        setSlider();
      }

      // リサイズ時の処理
      var resizeCallback = function (event) {
        if ($.script.isPCView() !== true) {
          w = window.innerWidth - 90;
          // コンテナサイズ調整
          $("#js-voice-slider").trigger(
            "configuration",
            {
              items: {
                width: w,
                visible: {
                  max: 1,
                },
              },
            },
            true
          );
          // リフレッシュ
          $("#js-voice-slider").trigger("updateSizes");
        } else {
          // コンテナサイズ調整
          $("#js-voice-slider").trigger(
            "configuration",
            {
              items: {
                width: "354",
                visible: {
                  max: "auto",
                },
                align: "center",
              },
            },
            true
          );
        }
      };

      //moreボタンクリック時
      var moreCallback = function (event) {
        $(this).closest(".m-voice-item").addClass("is-height-auto");
        $(this).next().attr("style", "");
        //  $(".m-voice-list").each(function(){
        //    $(".m-voice-item").find(".inner").tile();
        //  })
        //  if($.script.isPCView() === true){
        //  }else{
        //    $(".m-voice-item").find(".inner").attr("style", "");
        //  }
        // コンテナサイズ調整
        $("#js-voice-slider").trigger(
          "configuration",
          {
            items: {
              width: "354",
              visible: {
                max: "auto",
              },
              align: "center",
            },
          },
          true
        );
      };

      $(window).on("load resize orientationchange", resizeCallback);
      $(".js-voice-more").on("click", moreCallback);
    },
    /**============================================================
    *  [bannerSlider]
    *  description : topのスライドに適用する処理を記述
    ============================================================*/
    bannerSlider: function () {
      ($slider = $("#js-banner-slider")),
        (slideH = 60),
        (slideMode = "desktop"),
        (oldSlideMode = ""),
        (newCss = {
          height: (function () {
            var slideH;
            slideH = 60;
            return slideH;
          })(),
        });

      function setSlider() {
        $slider.carouFredSel({
          auto: false,
          swipe: {
            onTouch: true,
            onMouse: true,
          },
          //responsive: true, positionバグる
          height: newCss.height,
          items: {
            height: newCss.height,
            visible: {
              //"+2"
              min: 1,
              max: 4,
            },
          },
          scroll: {
            items: 1,
            duration: 600,
            pauseOnHover: false,
          },
          width: "100%",
          align: "center",
          prev: ".aside-banner-control.prev",
          next: ".aside-banner-control.next",
        });
      }

      function setHeightVal() {
        slideH = newCss.height;
      }

      //init
      setHeightVal();
      if ($.script.isPCView() === false) {
        if ($("#js-banner-slider").length > 0) setSlider();
      }

      // リサイズ時の処理
      var resizeBanner = function (event) {
        $("#js-banner-slider").trigger("updateSizes");
      };
      $(window).on("load resize orientationchange", resizeBanner);
    },
    /**============================================================
    *  [topSlider]
    *  description : topのスライドに適用する処理を記述
    ============================================================*/
    topSlider: function () {
      ($slider = $("#js-top-slider")),
        (slideH = "600px"),
        (slideMode = "desktop"),
        (oldSlideMode = "");

      function setSlider() {
        $slider.carouFredSel({
          items: 1,
          auto: 5000,
          //responsive: true, positionバグる
          height: slideH,
          items: {
            visible: 1,
            height: slideH,
          },
          scroll: {
            items: 1,
            fx: "crossfade",
            duration: 1800,
            pauseOnHover: false,
          },
        });
      }

      function setHeightVal() {
        if ($.script.isPCView() === true) {
          slideH = "600px";
          slideMode = "desktop";
        } else {
          slideH = 570 / 2;
          slideMode = "mobile";
        }
      }

      //init
      setHeightVal();
      if ($("#js-top-slider").length > 0) setSlider();

      //window resize
      var timerTopSlide = false;
      $(window).resize(function () {
        if (timerTopSlide !== false) {
          clearTimeout(timerTopSlide);
        }
        timerTopSlide = setTimeout(function () {
          if ($.script.isPCView() === true) {
            slideMode = "desktop";
          } else {
            slideMode = "mobile";
          }
          if (slideMode !== oldSlideMode) {
            setHeightVal();
          }
          oldSlideMode = slideMode;
        }, 200);
      });
    },
    /**============================================================
    *  [topHeight]
    *  description : topのスライドに適用する処理を記述
    ============================================================*/
    topHeight: function () {
      if ($(".js-height--top-service").length > 0) {
        $(".js-height--top-service").each(function () {
          $(".top-service-body").tile(3);
        });
      }

      //リサイズ時
      $(window).on("resize", function () {
        if ($.script.isPCView() === true) {
          //PC 高さぞろえ
          if (stateFlg == "mobile") {
            $(".js-height--top-service").each(function () {
              $(".top-service-body").tile(3);
            });
            stateFlg = "desktop";
          }
        } else {
          //スマホ 高さ成り行き
          $(".js-height--top-service").each(function () {
            $(".js-height--top-service")
              .find(".top-service-body")
              .attr("style", "");
          });
          if (stateFlg == "desktop") {
            stateFlg = "mobile";
          }
        }
      });

      if ($.script.isPCView() === true) {
        stateFlg = "desktop";
      } else {
        stateFlg = "mobile";
      }
    },
    /**============================================================
    *  [scrollTable]
    *  description : <table>に使用。PCのレイアウトのままSPに適用する処理を記述
    ============================================================*/
    scrollTable: function () {
      var self = this;
      $(".js-table-wrap table").each(function () {
        var tableWidth = "800px";
        $(this).wrap(
          '<div class="table-wrap-inner"><div class="table-container" style="width: ' +
            tableWidth +
            '; position: relative;" /></div>'
        );
        var tableContainer = $(this).parent("div");
        var columnHeaderWidth = 0;
        $(this)
          .find("tr")
          .each(function () {
            if ($(this).children("td").length == 0) {
              return true;
            }
            if ($(this).children(".js-table-th").length > 0) {
              columnHeaderWidth = $(this).children().eq(0).outerWidth();
            }
            return false;
          });
        if (columnHeaderWidth == 0) {
          return true;
        }
        tableContainer
          .parent()
          .after(
            $(
              '<div class="is-sp-visible" style="width: ' +
                ++columnHeaderWidth +
                'px; position: absolute; left: 0; top: 0; background: #000; overflow: hidden;" />'
            ).append(tableContainer.clone())
          );
        $(this).after(
          '<div class="is-sp-visible" style="width: ' +
            columnHeaderWidth +
            'px; position: absolute; top: 0; left: 0; height: 100%; background: #fff;">'
        );
      });
      $(window).on("load scroll resize", function () {
        var tableWidth = "800px";
        if ($.script.isPCView() === true) {
          $(".table-container").attr("style", "");
        } else {
          if ($(".table-container").width() + "px" != tableWidth) {
            $(".table-container").css("width", tableWidth);
          }
        }
      });
    },
  };
  $(domReady);
})(jQuery);
